import type { EnhancedProperty } from '../../@types/item';

export default (properties: { [key: string]: EnhancedProperty }) => {
  const adjustedProperties = { ...properties };

  if (properties?.drivingWheel) {
    adjustedProperties.drivingWheel = {
      ...properties.drivingWheel,
      category: {
        ...properties.drivingWheel.category,
        id: 1000,
        name: 'Basuppgifter',
        subCategory: null,
      },
    };
  }

  return adjustedProperties;
};
